export default "__VITE_PUBLIC_ASSET__4adf9254__"